





































import { Component, Vue, Watch } from 'vue-property-decorator'
import Axios from 'axios'
import { ARTISTTITLE_SEPARATOR_CODE, TRACKMATCHING_METHODS } from '@/store/modules/trackmatching'

let countryCities: {
  id: string
  listid: string
  name: string
  cities: {
    countryid: string
    listid: string
    name: string
  }
}[]

@Component({
  components: {
    Multiselect: require('vue-multiselect').default,
    ProgressLoader: require('@/components/ProgressLoader').default,
    HelpCircle: require('@/components/HelpCircle').default
  }
})
export default class ShazamCharts extends Vue {
  loading: boolean = false
  loadingCities: boolean = false
  modalOpen: boolean = false

  country: any = null
  city: any = null

  get disabled(): boolean {
    return !this.country
  }

  get countries() {
    return countryCities
  }

  get cities() {
    if (!this.country) return []

    return this.country.cities
  }

  get countryLinkName(): string {
    return this.country.name.toLowerCase().replace(/ /g, '-')
  }

  get cityLinkName(): string {
    return this.city.name.toLowerCase().replace(/ /g, '-')
  }

  get chartLink(): string {
    if (this.city) {
      return `https://www.shazam.com/charts/top-50/${this.countryLinkName}/${this.cityLinkName}`
    } else {
      return `https://www.shazam.com/charts/top-200/${this.countryLinkName}`
    }
  }

  get chartLinkLabel(): string {
    if (this.city) {
      return `View Top 50 for ${this.city.name}, ${this.country.name}`
    } else {
      return `View Top 200 for ${this.country.name}`
    }
  }

  open() {
    this.country = null
    this.city = null

    this.modalOpen = true
  }

  close() {
    this.modalOpen = false
  }

  countryFormatter(x) {
    return x.name
  }

  cityFormatter(x) {
    return x.name
  }

  async confirm() {
    if (this.loading) return

    this.loading = true

    try {
      let listId: string = this.country.listid

      if (this.city) {
        listId = this.city.listid
      }

      const { data } = await Axios.get(`/shazam/local-charts`, {
        params: {
          listId
        }
      })

      if (data.tracks.length === 0) {
        this.$buefy.dialog.alert({
          title: 'No results',
          message: 'Could not find any local tracks. Please try another area.'
        })
      } else {
        const lines = data.tracks.map(x => [x.artist, x.title])

        this.$store.commit('trackmatching/setMethod', TRACKMATCHING_METHODS.Shazam)
        this.$store.commit('trackmatching/setParsedLines', lines)
        this.$store.commit('trackmatching/setShowInputControls', false)
        this.$store.commit('trackmatching/setSeparator', ARTISTTITLE_SEPARATOR_CODE)
        this.$store.commit('trackmatching/setLines', lines.map(x => x.join(` ${ARTISTTITLE_SEPARATOR_CODE} `))) // TODO: Ugly hack, should do a proper rework of the trackmatcher
        this.$store.commit('trackmatching/setFuzzySearch', true)
        this.$store.commit('trackmatching/setSwapArtistTitle', false)

        let playlistPrefix: string = `Shazam ${this.country.name}`

        if (this.city) playlistPrefix += ` ${this.city.name}`

        this.$store.commit('trackmatching/setPlaylistPrefix', playlistPrefix)

        await this.$router.push({
          name: 'trackmatching parsed'
        })
      }
    } finally {
      this.loading = false
    }
  }

  async created() {
    if (!countryCities) {
      this.loadingCities = true

      const axiosClient = Axios.create({
        baseURL: '/'
      })

      const { data } = await axiosClient.get('/resources/country-cities.json')

      countryCities = data

      this.loadingCities = false
    }
  }

  @Watch('country')
  watchCountry() {
    this.city = null
  }
}
